export const SEARCH_PROVIDERS = {
    searxng: {
        name: 'SearXNG',
        label: 'SearXNG (self-hosted)',
        needs: 'baseUrl',
        fieldLabel: 'SearXNG address',
        fieldHint: 'The address of your SearXNG instance, for example https://search.example.edu. JSON output must be enabled in its settings (search.formats).',
    },
    tavily: {
        name: 'Tavily',
        label: 'Tavily',
        needs: 'apiKey',
        fieldLabel: 'Tavily API key',
        fieldHint: 'From app.tavily.com, under API keys. It starts with tvly-.',
    },
    brave: {
        name: 'Brave Search',
        label: 'Brave Search',
        needs: 'apiKey',
        fieldLabel: 'Brave Search API key',
        fieldHint: 'The subscription token from api-dashboard.search.brave.com, under API keys.',
    },
    exa: {
        name: 'Exa',
        label: 'Exa',
        needs: 'apiKey',
        fieldLabel: 'Exa API key',
        fieldHint: 'From dashboard.exa.ai, under API keys.',
    },
    serpapi: {
        name: 'SerpApi',
        label: 'SerpApi (Google results)',
        needs: 'apiKey',
        fieldLabel: 'SerpApi API key',
        fieldHint: 'Your private API key, shown at serpapi.com/manage-api-key (64 characters). Not the same service as SearchApi.',
    },
    searchapi: {
        name: 'SearchApi',
        label: 'SearchApi (Google results)',
        needs: 'apiKey',
        fieldLabel: 'SearchApi API key',
        fieldHint: 'Your API key from the searchapi.io dashboard (24 characters). Not the same service as SerpApi.',
    },
};
//# sourceMappingURL=search-providers.js.map